const pageNameKey = "errorPane";

export const errorPaneEn = {
  [pageNameKey]: {
    refreshButtonText: "Refresh",
  },
};

export const errorPanePtBr = {
  [pageNameKey]: {
    refreshButtonText: "Atualizar",
  },
};

export const errorPaneDe = {
  [pageNameKey]: {
    refreshButtonText: "Aktualisieren",
  },
};

export const errorPaneZhHans = {
  [pageNameKey]: {
    refreshButtonText: "刷新",
  },
};

export const errorPaneIt = {
  [pageNameKey]: {
    refreshButtonText: "Ricarica",
  },
};

export const errorPaneEs = {
  [pageNameKey]: {
    refreshButtonText: "Actualizar",
  },
};

export const errorPaneNl = {
  [pageNameKey]: {
    refreshButtonText: "bewerken",
  },
};

export const errorPaneTr = {
  [pageNameKey]: {
    refreshButtonText: "Yenile",
  },
};
